module.exports = __webpack_public_path__ + "img/zhnp_1@2x.66dc4f42.png";